// Shared across every proposal: the marketing bento tiles.
// Edit here once; every client's page picks it up.

export const marketingTiles = [
  {
    size: "hero",
    title: "HDR twilight photography",
    text: "Top photographers, a twilight shoot, and a light touch of enhancement so the sky truly glows.",
    image: "listings/mukilteo-modern-twilight-listed-by-adam.webp",
    imageSmall: "listings/mukilteo-modern-twilight-listed-by-adam-800.webp",
    caption: "Mukilteo, listed by Adam",
  },
  {
    size: "medium",
    title: "Staging",
    text: "Rooms that photograph well and show even better.",
    images: ["staging/staging-living-room.webp", "staging/staging-kitchen.webp", "staging/staging-5.webp"],
    caption: "Staging from my listings",
  },
  {
    size: "medium",
    title: "3D tour",
    text: "Buyers walk through before they ever visit.",
    image: "marketing/3d-tour-dollhouse.webp",
    caption: "3D tour of one of my listings",
  },
  {
    size: "wide",
    title: "Custom property website",
    text: "Your home gets its own website.",
    image: "marketing/property-website-laptop.webp",
    imageFit: "contain",
    transparent: true,
    caption: "A property website from one of my listings.",
  },
  {
    size: "wide",
    title: "Everywhere buyers search",
    text: "NWMLS, brokerage sites, Zillow, Redfin, Facebook and Instagram.",
  },
  {
    size: "medium",
    title: "Targeted e-blast",
    text: "Sent to top local agents and their buyers.",
    image: "marketing/eblast-bellevue-listing.webp",
    imagePosition: "top",
    caption: "An e-blast from one of my Bellevue listings.",
  },
  {
    size: "tallWide",
    title: "Open houses",
    display: "Saturday, 2 PM",
    text: "Your first open house starts the moment your home goes Active.",
  },
  {
    size: "wide",
    title: "Luxury and international reach",
    text: "For homes in the top 5% of local prices: The Wall Street Journal, Robb Report, Mansion Global, Unique Homes and syndication to 90 prominent international search sites.",
    image: "marketing/luxury-ad-placements.webp",
    imageFit: "contain",
    caption: "Sample placements from my listings",
  },
];
